module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/instagram-e1bcc9b53765493f2e803e6207c4e082.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/instagram.svg
// module id = Eyez
// module chunks = 24